<template>
  <v-container fluid class="px-0">
    <div class="directory-page">
      <v-row>
        <v-col v-for="employee in employees_active" :key="employee.id" md="4" sm="6" cols=12>
          <v-row>
            <v-col cols="12">
              <v-card class="user-card ma-1" min-height="150">
                <v-card-text class="pa-5 pt-9 fill-height">
                  <v-row no-gutters class="fill-height">
                    <v-col cols="12" sm="4" xl="4" class="d-flex justify-center align-center flex-column">
                      <div
                        class="avatar-wrapper">
                        <v-img
                          class="user-avatar"
                          contain
                          :src="employee.employeeimage">
                        </v-img>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="8" xl="8" class="pl-0 pl-sm-4 d-flex flex-column align-center align-sm-start"  >
                      <p class="user-name greyMedium--text font-weight-regular">{{ employee.employeename }}</p>
                      <a class="user-email" :href="'mailto:' + employee.employeeemail">{{ employee.employeeemail }}</a>
                      <div class="user-info" v-if="employee.health.vaccinationstatus=='Full Vaccination' || employee.health.vaccinationstatus.includes('Booster')">
                        <div style="display: inline-block;vertical-align: middle;">
                          <v-img align="left" v-if="employee.health.vaccinationstatus=='Full Vaccination' || employee.health.vaccinationstatus.includes('Booster')" src="@/assets/vaccination_badge_30.png" contain max-width="25" min-width="25"></v-img></div>
                        <div style="display: inline-block; vertical-align: middle;">&nbsp;<b>{{ employee.health.vaccinationstatus }}</b>&nbsp;{{ employee.health.vaccinationdate3!=null ? formatDate(employee.health.vaccinationdate3) : formatDate(employee.health.vaccinationdate2) }}</div>
                      </div>
                      <div class="user-info" v-if="employee.employeebirthdate!==null && showBirthdate(employee.employeebirthdate)">
                        <div style="display: inline-block;vertical-align: middle;"><v-icon color="blue darken-2">mdi-cake</v-icon></div>
                        <div style="display: inline-block; vertical-align: middle;">&nbsp;<b>Birthday</b>&nbsp;{{ formatDateMonthDay(employee.employeebirthdate) }}  {{  }}</div>
                      </div>

                          
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>

import { mapState, mapActions } from 'vuex';
import { dateDifference, formatDate, formatDateMonthDay, formatDateThisYear } from '@/mixins/date';

export default {
  name: 'Directory',
  computed: {
    ...mapState('Employee', ['employees',]),
  },
  data() {
    return {
      directory: null,
      employees_active: [],
    }
  },
  methods: {
    ...mapActions('Employee', ["getEmployeesRequest",]),
    formatDate,
    formatDateMonthDay,
    formatDateThisYear,
    dateDifference,
    showBirthdate(birthdate){
      let today = new Date();
      let diff = dateDifference(today, formatDateThisYear(birthdate));
      if(diff>-2 && diff<30) return true;
      else return false;
    }

  },
  async created() {
    await this.getEmployeesRequest();
    this.employees_active = this.employees.filter(employee=>employee.employeestatus=='Active');
  }
}
</script>

<style src="./Directory.scss" lang="scss"/>
